import styled from "styled-components";

export const PageTitle = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  span {
    font-family: Asap;
    font-weight: bold;
    font-size: 14px;
    text-align: left;
    color: #c4c4c4;
    text-transform: uppercase;
  }
  svg,
  img {
    width: 25px;
    height: 25px;
    margin-right: 9px;
  }
  line,
  rect,
  path {
    stroke: #c4c4c4;
  }
`;

// Wrapper que padroniza as labels do formulário do modal de estoque
// no padrão visual dos formulários do sistema (ver supplement/styles.js).
export const StyledFormContainer = styled.div`
  .ant-form-item-label > label {
    color: #9074bf;
    font-family: "Asap", sans-serif;
    font-size: 14px;
    font-weight: bold;
  }

  /* asterisco de obrigatório depois do texto, na cor da label */
  .ant-form-item-label > label.ant-form-item-required::before {
    display: none;
  }
  .ant-form-item-label > label.ant-form-item-required::after {
    content: "*";
    color: inherit;
    margin-left: 2px;
  }

  /* erro: label vermelha quando o campo tem erro */
  .label-error {
    color: #d44c4c !important;
  }

  .ant-switch-checked {
    background-color: #a9c133 !important;
  }
`;

export const CardDietItemDetails = styled.div`
  background-color: #ededed;
  padding: 1rem;

  .ant-form-item-label > label {
    color: #9074bf;
    font-family: "Asap", sans-serif;
    font-size: 14px;
    font-weight: bold;
  }

  /* asterisco de obrigatório depois do texto, na cor da label */
  .ant-form-item-label > label.ant-form-item-required::before {
    display: none;
  }
  .ant-form-item-label > label.ant-form-item-required::after {
    content: "*";
    color: inherit;
    margin-left: 2px;
  }

  /* erro: label vermelha quando o campo tem erro */
  .label-error {
    color: #d44c4c !important;
  }

  .ant-switch-checked {
    background-color: #a9c133 !important;
  }
`;
